import { lightDefaultTheme } from "@blocknote/mantine";

// Custom editor theme
export const editorTheme = {
  colors: {
    editor: {
      text: "var(--gray-800)",
      background: "hsl(var(--neutral))",
    },
    menu: {
      text: "var(--gray-800)",
      background: "var(--gray-50)",
    },
    tooltip: {
      text: "var(--gray-600)",
      background: "var(--gray-100)",
    },
    hovered: {
      text: "var(--gray-900)",
      background: "var(--gray-200)",
    },
    selected: {
      text: "var(--gray-900)",
      background: "var(--gray-200)",
    },
    disabled: {
      text: "var(--gray-400)",
      background: "var(--gray-100)",
    },
    shadow: "var(--gray-200)",
    border: "var(--gray-200)",
    sideMenu: "#bababa",
    highlightColors: lightDefaultTheme.colors.highlights,
  },
  borderRadius: 6,
};
